import { Typography, Paper } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ShareItems from '.';

export default function Followers({ setNextStepType, setIsOpen }) {
  const history = useHistory();

  return (
    <Paper
      elevation={1}
      sx={{
        height: '100%',
        padding: '48px 32px',
        borderRadius: '12px',
        width: '100%',
        boxShadow: 'none',
        textAlign: 'center',
      }}
    >
      <Typography
        sx={{
          mb: 2,
          fontWeight: '700',
          fontSize: '28px',
          lineHeight: '40px',
          color: '#232B35',
        }}
      >
        Turn contacts & followers into advisors
      </Typography>
      <Typography
        sx={{
          mb: 2,
          fontWeight: '400',
          fontSize: '16px',
          lineHeight: '30px',
          color: '#232B35',
        }}
      >
        The bigger your board, the more ideas and advocates for you. We
        recommend sharing your advisory board wherever you have the largest
        following. Business contacts and followers will be able to join for
        free!
      </Typography>
      <Typography
        sx={{
          mb: 2,
          fontWeight: '700',
          fontSize: '20px',
          lineHeight: '40px',
          color: '#232B35',
        }}
      >
        Click below to see how easy it is:
      </Typography>
      <ShareItems setNextStepType={setNextStepType} setIsOpen={setIsOpen} />
      <Typography
        component="button"
        onClick={() => history.push('/advisors/search')}
        sx={{
          mt: 1,
          display: 'inline-block',
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          fontWeight: '600',
          fontSize: '14px',
          lineHeight: '18px',
          color: '#2b71f6',
          textDecoration: 'underline',
        }}
      >
        or invite executives from our network
      </Typography>
    </Paper>
  );
}
